import { useState } from 'react';
import { useMovementsByAsset } from '../hooks';
import { MovementTypeBadge } from './MovementTypeBadge';
import { MovimentacoesModal } from './MovimentacoesModal';
import { formatarData, formatarOrigemDestino } from '../utils/formatters';

interface Props {
  assetId: string;
}

export function MovimentacoesTab({ assetId }: Props) {
  const [modalOpen, setModalOpen] = useState(false);
  const query = useMovementsByAsset(assetId, { limit: 5 });

  if (query.isLoading) {
    return <p className="py-6 text-center text-sm text-gray-500">Carregando movimentações...</p>;
  }
  if (query.isError) {
    return (
      <p className="py-6 text-center text-sm text-red-600">
        Falha ao carregar movimentações.
      </p>
    );
  }
  const items = query.data?.data ?? [];
  if (items.length === 0) {
    return <p className="py-6 text-center text-sm text-gray-500">Nenhuma movimentação registrada.</p>;
  }

  return (
    <>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
            <tr>
              <th className="px-3 py-2 text-left">Data</th>
              <th className="px-3 py-2 text-left">Tipo</th>
              <th className="px-3 py-2 text-left">Descrição</th>
              <th className="px-3 py-2 text-left">Responsável (origem → destino)</th>
              <th className="px-3 py-2 text-left">Localização (origem → destino)</th>
              <th className="px-3 py-2 text-left">Executor</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {items.map((m) => {
              const dt = new Date(m.occurredAt);
              return (
                <tr key={m.id}>
                  <td className="px-3 py-2 text-gray-700 whitespace-nowrap">
                    {formatarData(m.occurredAt)}
                    <span className="ml-1 text-xs text-gray-500">
                      {dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </td>
                  <td className="px-3 py-2"><MovementTypeBadge type={m.type} /></td>
                  <td className="px-3 py-2 text-gray-700">{m.description}</td>
                  <td className="px-3 py-2 text-gray-700">
                    {formatarOrigemDestino(m.previousCustodianName, m.newCustodianName)}
                  </td>
                  <td className="px-3 py-2 text-gray-700">
                    {formatarOrigemDestino(m.previousLocationName, m.newLocationName ?? m.locationName)}
                  </td>
                  <td className="px-3 py-2 text-gray-700">
                    {m.performedByUserName ?? m.performedByUserEmail ?? '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="mt-3 flex justify-end">
        <button
          onClick={() => setModalOpen(true)}
          className="text-sm text-blue-600 hover:underline"
        >
          Ver todas as movimentações
        </button>
      </div>
      <MovimentacoesModal open={modalOpen} onClose={() => setModalOpen(false)} assetId={assetId} />
    </>
  );
}
